
import { computed, defineComponent, PropType, ref } from 'vue';

export type ImgSizeType = 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
export default defineComponent({
  name: 'ComponentName',
  props: {
    url: {
      type: String,
      required: true,
    },
    size: {
      type: String as PropType<ImgSizeType>
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    circular: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const imgSize = computed((): string => {
      switch (props.size) {
        case 'sm':
          return '32px';
        case 'md':
          return '64px';
        case 'lg':
          return '120px';
        case 'xl':
          return '256px';
        case 'xxl':
          return '300px';
        case 'xxxl':
          return '512px';
        default:
          return '100px';
      }
    });
    const classes = ref([
      's-img',
      props.bordered && 's-img--bordered',
      props.circular && 's-img--circular',
    ]);
    return { imgSize, classes };
  },
});
